import { createEmitter } from "ts_utils";
import { Templates } from "../ui/Templates";
import { AddStudentDialog } from "./AddStudentDialog";
import { StudentManager } from "./StudentManager";
import { TeamsDialog, TeamsDialogEvent } from "../teams/TeamsDialog";
import { Services } from "../services/Services";
import { Student } from "./Student";
import { RdtoMessage } from "ts_utils";
import { TeamDO } from "./TeamDO";
import { selectStudentListItem, selectStudentDg }
	from "../ui/templates/studentSelectTemplates";

export class StudentSelectionWindow {
	
	private _ui:HTMLDivElement;
	private _addStudentBtn:HTMLButtonElement;
	private _teachersBtn:HTMLButtonElement;
	private _studentList:HTMLDivElement;
	
	private _studentListItems:Array<StudentSelectionListItem>;
	
	public get event() { return this._emitter.event; }
	private _emitter = createEmitter<StudentSelectionWindowEvent>();
	
	constructor(){
		this._init();
	}
	
	private _init():void {
		this._draw();
		StudentManager.loadFromStorage();
		this._populateStudentList();
		this._addListeners();
	}
	
	private _draw():void {
		this._ui = Templates.createDiv(selectStudentDg);
		this._addStudentBtn = this._ui.querySelector('.ss-addStudentBtn');
		this._teachersBtn = this._ui.querySelector('.ss-teachersBtn');
		this._studentList = this._ui.querySelector('.ss-studentList');
		
		document.body.append(this._ui);
	}
	
	private _populateStudentList():void {
		while (this._studentList.children.length > 0){
			this._studentList.lastChild.remove();
		}
		
		this._studentListItems = [];
		for (let student of StudentManager.students){
			let li = new StudentSelectionListItem();
			li.student = student;
			li.ui = Templates.createDiv(selectStudentListItem);
			li.nameDiv.innerHTML = student.name;
			if (student.teamCode != null){
				li.teamDiv.innerHTML = student.teamName?? "On a Team";
			}
			else {
				li.teamDiv.innerHTML = "No Team";
			}
			
			this._studentListItems.push(li);
			this._studentList.append(li.ui);
		}
	}
	
	private _onStudentLiClick = async (e:MouseEvent):Promise<void> => {
		this._removeListeners();
		
		let li = this._studentListItems.find((li) => li.ui === e.currentTarget);
		
		if (li.student.teamCode != null){
			let rdto = await Services.getTeamByCode(li.student.teamCode);
			if (!rdto.success){
				if (rdto.message === RdtoMessage.NOT_FOUND){
					li.student.teamCode = null;
					li.student.teamName = null;
					StudentManager.saveToStorage(false);
				}
			}
			else {
				if (li.student.teamName == null){
					li.student.teamName = rdto.data.name;
					StudentManager.saveToStorage(false);
				}
				li.student.team = TeamDO.fromTeamDto(rdto.data);
			}
		}
		
		StudentManager.setCurrentStudentByName(li.student.name);
		
		let event = new StudentSelectionWindowEvent();
		event.type = StudentSelectionWindowEvent.STUDENT_SELECTED;
		this._emitter.emit(event);
		
		this._ui.remove();
	}
	
	private _onAddStudentBtnClick = (e:MouseEvent):void => {
		this._ui.classList.add("overrideDisplayNone");
		this._removeListeners();
		
		let dg = new AddStudentDialog();
		dg.studentEvent.on((student) => {
			dg.studentEvent.offAll();
			if (student != null){
				this._populateStudentList();
			}
			this._ui.classList.remove("overrideDisplayNone");
			this._addListeners();
		});
	}
	
	private _onTeachersBtnClick = (e:MouseEvent):void => {
		this._ui.classList.add("overrideDisplayNone");
		this._removeListeners();
		
		let dg = new TeamsDialog();
		dg.event.on((e:TeamsDialogEvent) => {
			if (e === TeamsDialogEvent.Finished){
				//dialog finished
				dg.event.offAll();
				this._populateStudentList();
				this._addListeners();
				this._ui.classList.remove("overrideDisplayNone");
			}
		});
	}
	
	private _onMouseWheel = (e:WheelEvent):void => {
		e.preventDefault();
		this._studentList.scrollTop += Math.round(e.deltaY);
	}
	
	private _addListeners():void {
		this._studentListItems.forEach((li) => {
			li.ui.addEventListener("click", this._onStudentLiClick);
		});
		
		this._addStudentBtn.addEventListener("click",
			this._onAddStudentBtnClick);
		this._teachersBtn.addEventListener("click", this._onTeachersBtnClick);
		
		this._ui.addEventListener("wheel", this._onMouseWheel);
	}
	
	private _removeListeners():void {
		this._studentListItems.forEach((li) => {
			li.ui.removeEventListener("click", this._onStudentLiClick);
		});
		
		this._addStudentBtn.removeEventListener("click",
			this._onAddStudentBtnClick);
		this._teachersBtn.removeEventListener("click",
			this._onTeachersBtnClick);
		
		this._ui.removeEventListener("wheel", this._onMouseWheel);
	}
}

class StudentSelectionListItem {
	public ui:HTMLDivElement;
	public student:Student;
	
	public get nameDiv():HTMLDivElement {
		return this.ui.querySelector(".ss-listItem-name");
	}
	public get teamDiv():HTMLDivElement {
		return this.ui.querySelector(".ss-listItem-team");
	}
}

export class StudentSelectionWindowEvent {
	public type:string;
	
	public static readonly STUDENT_SELECTED:string = "studentSelected";
}